export default __webpack_public_path__ + "static/media/laptop_es.73db5693.png";